import ActiveWorkoutScreen from "./ActiveWorkoutScreen";

export default ActiveWorkoutScreen;